import axios, { type AxiosInstance, type AxiosResponse } from 'axios'
import type { ApiError } from '@/types'

const API_BASE = import.meta.env.VITE_API_URL ?? ''

export const apiClient: AxiosInstance = axios.create({
  baseURL: `${API_BASE}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 30_000,
})

// Token getter — set by the auth layer once App Bridge has a token
let sessionTokenGetter: (() => Promise<string | null>) | null = null

export function setSessionTokenGetter(getter: () => Promise<string | null>): void {
  sessionTokenGetter = getter
}

apiClient.interceptors.request.use(async (config) => {
  if (sessionTokenGetter) {
    try {
      const token = await sessionTokenGetter()
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    } catch {
      // continue without token — server will return 401
    }
  }
  return config
})

// Normalise error responses
apiClient.interceptors.response.use(
  (res: AxiosResponse) => res,
  (error) => {
    const apiError: ApiError = error.response?.data ?? {
      success: false,
      message: error.message ?? 'An unexpected error occurred.',
    }
    return Promise.reject(apiError)
  },
)

export default apiClient
